import React, { FC, useContext, useEffect } from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { showTooltipAction } from 'actions/tooltipAction'
import { fetchUniNoticeAction } from 'actions/uninotice/uniNoticeAction'
import { ProfileTooltipContext } from 'components/page/UserProfile/Context/CreateProfileContext'
import { LinkColor } from 'components/presentational/link'
import { VerifiedIconParams } from 'components/presentational/title/common.types'
import { size } from 'components/presentational/title/constants'
import { VerifiedIcon } from 'components/presentational/title/VerifiedIcon'
import { Tooltip } from 'components/presentational/Tooltip/Tooltip'
import {
  TooltipText,
  WrapperPosition,
} from 'components/presentational/Tooltip/Tooltip.styled'
import { TextPosition } from 'components/presentational/Tooltip/Tooltip.types'
import { photoVerificationInfoNoticeId } from 'components/uninotice/uniNoticeIdList'
import {
  getSessionKeyValue,
  setSessionKeyValue,
} from 'functions/sessionStorage'
import { useTooltip } from 'hooks/useTooltip'

export const verificationProfileTooltip = 'verificationProfileTooltip'

export const VerifiedIconWithTooltip: FC<VerifiedIconParams> = ({
  name,
  gender,
  iconUid,
}) => {
  const dispatch = useDispatch()
  const [tooltipState, toggleTooltipState] = useTooltip(
    verificationProfileTooltip
  )
  const { position, zIndex } = useContext(ProfileTooltipContext)

  const handleClick = () => {
    dispatch(fetchUniNoticeAction(photoVerificationInfoNoticeId))
  }

  useEffect(() => {
    const isShowNotice = getSessionKeyValue(verificationProfileTooltip)
    if (gender && !isShowNotice) {
      setSessionKeyValue(verificationProfileTooltip, true)
      dispatch(showTooltipAction(verificationProfileTooltip))
    }
  }, [dispatch, gender])

  return (
    <WrapperPosition $position={position} onClick={toggleTooltipState}>
      <VerifiedIcon size={size} iconUid={iconUid} />
      {tooltipState && (
        <Tooltip
          width={160}
          position={position}
          textPosition={TextPosition.Center}
          indent={size * 2}
          zIndex={zIndex}
        >
          <TooltipText>
            <Name>{name}</Name>{' '}
            <FormattedMessage
              id="tooltip.note"
              defaultMessage="{gender, select, M {подтвердил} F {подтвердила} other {подтвердил}} свою фотографию."
              values={{
                gender,
              }}
            />
          </TooltipText>
          <LinkColor onClick={handleClick}>
            <FormattedMessage id="link.more" defaultMessage="Подробнее" />
          </LinkColor>
        </Tooltip>
      )}
    </WrapperPosition>
  )
}

const Name = styled.strong`
  overflow-wrap: anywhere;
`
